document.addEventListener('DOMContentLoaded', () => {
  let contrast = localStorage.theme === 'contrast' || window.matchMedia('(prefers-contrast: more)').matches;
  let fontSize = localStorage.enlarged === 'true';

  const contrastToggle = document.getElementById('contrastToggle') as HTMLButtonElement;
  const contrastIncreaseLabel = document.getElementById('contrastIncrease') as HTMLSpanElement;
  const contrastDecreaseLabel = document.getElementById('contrastDecrease') as HTMLSpanElement;

  const fontSizeToggle = document.getElementById('fontSizeToggle') as HTMLButtonElement;
  const fontSizeIncreaseLabel = document.getElementById('fontSizeIncrease') as HTMLSpanElement;
  const fontSizeDecreaseLabel = document.getElementById('fontSizeDecrease') as HTMLSpanElement;
  const updateContrast = () => {
    if (contrast) {
      contrastToggle.setAttribute('aria-pressed', 'true');
      document.documentElement.setAttribute('data-theme', 'contrast');
      localStorage.setItem('theme', 'contrast');
      contrastToggle.setAttribute('aria-label', contrastDecreaseLabel.innerText)
    } else {
      contrastToggle.setAttribute('aria-pressed', 'false');
      document.documentElement.removeAttribute('data-theme');
      localStorage.setItem('theme', '');
      contrastToggle.setAttribute('aria-label', contrastIncreaseLabel.innerText);
    }
  }

  const updateFontSize = () => {
    if (fontSize) {
      fontSizeToggle.setAttribute('aria-pressed', 'true');
      document.documentElement.setAttribute('data-font', 'enlarged');
      localStorage.setItem('enlarged', 'true');
      fontSizeToggle.setAttribute('aria-label', fontSizeDecreaseLabel.innerText);
    } else {
      fontSizeToggle.setAttribute('aria-pressed', 'false');
      document.documentElement.removeAttribute('data-font');
      localStorage.setItem('enlarged', 'false');
      fontSizeToggle.setAttribute('aria-label', fontSizeIncreaseLabel.innerText);
    }
  }

  updateContrast();
  updateFontSize();

  contrastToggle.addEventListener('click', () => {
    contrast = !contrast;
    updateContrast();
  });

  fontSizeToggle.addEventListener('click', () => {
    fontSize = !fontSize;
    updateFontSize();
  });
});
